import api from 'api';
import { components } from 'api/types';

type KillTasksResult = components['schemas']['KillTasksResult'];

export default function killTasks(projectId: string, workflowId: string, taskIds: string[]): Promise<KillTasksResult> {
  return api
    .post(`projects/${projectId}/workflows/${workflowId}/tasks/bulk-kill`, {
      json: { task_ids: taskIds },
    })
    .json();
}
